import React, { useState } from "react";
import { useAsyncDebounce } from "react-table";

import styles from './GlobalFilter.module.css';

export const GlobalFilter = ({ filter, setFilter }) => {
  const [value, setValue] = useState(filter);

  const onChange = useAsyncDebounce((value) => {
    setFilter(value || undefined);
  }, 500);

  return (
    <div className={`${styles.globalFilter}`}>
      <span className={`fw-bold ${styles.showSearchText}`}>Search:&nbsp;&nbsp;</span>
      <input
        className={styles.input}
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
      />
      {/* <select value={filter || ""} onChange={e => setFilter(e.target.value)}>
        <option value={"HRSI"}>Nexi</option>
        <option value={"DACH"}>DACH</option>
        <option value={"Italy"}>Italy</option>
      </select> */}
    </div>
  );
};
